<div class="ag-form-control" #viewControl [class.has-errors]="control.invalid && control.dirty">
  <div class="ag-value">
    <textarea [formControl]="control" [placeholder]="" [id]="formControlName" [name]="formControlName" [rows]="rows" (focus)="onFocus()" (blur)="onBlur()"></textarea>
    <label for="value">{{ label }}</label>
  </div>
</div>
